import About from "./about";
import Contact from "./contact";
import Home from "./home";
import NavBar from "./navBar";
import Portfolio from "./portfolio";
import Skills from "./skills";
import SocialLinks from "./socialLinks";

function App() {
  return (
    <>
      <NavBar />
      <Home />
      <About />
      <Portfolio />
      <Skills />
      <Contact />
      <SocialLinks />
    </>
  );
}

export default App;
